module.exports = __webpack_public_path__ + "static/media/sanmartindeporres.2b9ca33c.jpg";